<template>
  <div>
    <div class="layout-main" :class="{ 'grid-template': templateClass }">
      <transition name="slide-fade-left">
        <sidebar
          :class="{ small: !showSidebar }"
          @hideSidebar="disbaleSidebar"
          @showSidebar="activateSidebar"
        />
      </transition>
      <div class="bg-sidebar"></div>
      <div>
        <!--       -->
        <Topbar />
        <div style="height: 60px"></div>
        <transition :name="settings.routerAnimation" mode="out-in">
          <router-view @showHelp="showHelpModal" />
        </transition>
      </div>
    </div>

    <div
      class="overlay-sidebar"
      v-if="showSidebar"
      @click="disbaleSidebar"
    ></div>
    <transition name="slide-fade">
      <guide-help :show="showHelp" @closeHelp="closeHelpModal" />
    </transition>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Sidebar from "@/components/common/sidebar";
import Topbar from "@/components/common/topbar";
import guideHelp from "@/components/jab/guides/guideHelp";
export default {
  name: "App",
  data() {
    return {
      showHelp: false,
      showSidebar: true,
      templateClass: true
    };
  },
  created() {
    let that = this;
    window.onload = function(e) {
      that.sidebarResponsive();

      window.addEventListener("resize", () => {
        that.sidebarResponsive();
      });
    };
  },
  components: {
    Sidebar,
    Topbar,
    guideHelp
  },
  computed: {
    ...mapState(["settings"])
  },
  methods: {
    showHelpModal() {
      this.showHelp = true;
    },
    closeHelpModal() {
      this.showHelp = false;
    },
    activateSidebar() {
      if (window.innerWidth > 1440) {
        console.log("top-bar", document.querySelector(".top-bar"));
        document.querySelector(".top-bar").classList.remove("full");

        this.templateClass = true;
      }
      this.showSidebar = true;
    },
    disbaleSidebar() {
      document.querySelector(".top-bar").classList.add("full");
      this.showSidebar = false;
      this.templateClass = false;
    },
    sidebarResponsive() {
      if (window.innerWidth < 1440) {
        this.disbaleSidebar();
      } else {
        this.activateSidebar();
      }
    }
  }
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Nunito:wght@200;300;400;600;700;800&display=swap");
svg {
  overflow: hidden;
  vertical-align: middle !important;
}
* {
  font-family: "Nunito", sans-serif;
}
.app {
  overflow-x: hidden;
}
.layout-main {
  display: grid;
  grid-template-columns: 60px 1fr;
  a {
    &:hover {
      box-shadow: none;
    }
  }
}
.grid-template {
  grid-template-columns: 234px 1fr;
}
*:focus {
  outline: none !important;
}
.btn-outline {
  padding: 10px 15px;
  border: 1px solid #557efb;
  font-family: "Nunito", sans-serif;
  font-size: 16px;
  background-color: #fff;
  border-radius: 10px;
  font-weight: 600;
  color: #557efb;
}
.btn-fill {
  padding: 10px 15px;
  border: 1px solid #557efb;
  font-family: "Nunito", sans-serif;
  font-size: 16px;
  background-color: #557efb;
  color: #fff;
  border-radius: 10px;
  font-weight: normal;
}
.btn-outline-primary {
  border-color: #557efb !important;
}
.btn-primary {
  background-color: #557efb !important;
}
.btn-primary:hover,
.btn-primary:active,
.btn-primary:focus {
  background-color: #496cd4 !important;
}
.top-bar {
  .actions > .btn-primary,
  .actions > .btn-outline-primary {
    border-radius: 10px;
  }
  .notifications-panel {
    .btn {
      border-radius: 0.2rem;
    }
  }
}
.btn-outline-primary:hover {
  background-color: #557efb;
  svg {
    path {
      fill: #fff !important;
    }
    fill: #fff !important;
  }
}
@media (max-width: 1440px) {
  .overlay-sidebar {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.14);
    z-index: 7;
  }
}
button:focus {
  outline: none;
}

.tracked,
.deck,
.stationed {
  /* width */
  ::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #474d52;
    border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}

.slide-fade-enter-active {
  transition: all 0.2s ease;
}
.slide-fade-leave-active {
  transition: all 0.2s ease-in-out;
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(20px);
  opacity: 0;
}

.slide-fade-left-enter-active {
  transition: all 0.4s ease;
}
.slide-fade-left-leave-active {
  transition: all 0s ease-in-out;
}
.slide-fade-left-enter
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-100%);
  opacity: 0;
}
.slide-fade-left-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}

// fixes slight flickering after moving
.list-leave-active {
  display: none !important;
}

.bg-sidebar {
  height: 100%;
  width: 60px;
}
@media (min-width: 1441px) {
  .bg-sidebar {
    display: none;
  }
}
</style>
